import callDetailsFromDisplayAndSearchFields, {
  CallDetailsMap,
} from 'utils/callDetailsFromDisplayAndSearchFields';
import xor from 'lodash/xor';
import {Call} from '@store/call-card/Call';
import {List} from 'immutable';
import {Field} from 'records/Search';

/**
 * CallDetails tweaks for CallCard v3
 * Eventually should be repurposed into a new Call Details component once CallCard v2 is dead
 */
export function newCallCardDetails(call: Call, searchFields?: List<Field>) {
  if (call.rawFields.isEmpty()) return;

  let callDetails = callDetailsFromDisplayAndSearchFields(call.rawFields.toJS(), searchFields);
  callDetails = dedupeMoreInformation(call, callDetails);
  callDetails = dedupeParticipants(callDetails);

  return callDetails;
}

/**
 * If 'More Information' is the same as another line item, then delete it.
 */
function dedupeMoreInformation(call: Call, callDetails: CallDetailsMap) {
  // Only add More Information if it's unique
  if (callDetails.some(({value}) => value === call.template.lineThree)) {
    return callDetails;
  } else {
    return callDetails.set('More Information', {
      name: 'More Information',
      value: call.template.lineThree,
    });
  }
}

const Participants = 'Participants';
const ParticipantEmails = 'Participant Emails';

/**
 * Don't repeat entries between Participants and Participant Emails.
 * Remove matches from Participants
 */
function dedupeParticipants(callDetails: CallDetailsMap) {
  // Don't try to dedupe if we don't have both fields
  if (!callDetails.has(Participants) || !callDetails.has(ParticipantEmails)) return callDetails;

  const participants = callDetails.get(Participants)!.value ?? '';
  const participantEmails = callDetails.get(ParticipantEmails)!.value ?? '';
  const split = s => s.split(',').map(s => s.trim());

  const matchedEmails = xor(split(participantEmails), split(participants));

  if (matchedEmails.length === 0) {
    return callDetails;
  } else {
    const newParticipants = split(participants).filter(p => matchedEmails.includes(p));
    return callDetails.set(Participants, {
      name: Participants,
      value: newParticipants.join(', '),
    });
  }
}
